import { Button, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';

export const StyledDialogTitle = styled(DialogTitle)({
  padding: '8px 40px 16px 40px',
});

export const StyledDialogContent = styled(DialogContent)({
  padding: '12px 0px',
});

export const StyledDialogActions = styled(DialogActions)({
  padding: '24px 40px',
});

export const StyledCancelButton = styled(Button)({
  background: 'white',
  color: '#004A8B',
  '&:hover': {
    backgroundColor: '#f7f7f7',
    boxShadow: 'none',
  },
});